import React from "react";
import { useFormContext } from "react-hook-form";
import { Grid, TitleDescriptionOne } from "@comfama/comfama-ui";
import {
    FormInputLib,
    GlobalInputProps,
} from "../../atoms/form-input/FormInputLib";
import { listCityAmva } from "./utils/listCityAmva";

interface IFormMentoriaTalentoSection {
    fields: Array<Omit<GlobalInputProps,'maxLength'>>;
    title: string;
}

const UnemploymentLabel = "Desempleado";

const UnderOathSection = () => {
   return (
      <div className="under-oath">
         <p>
            Al enviar este formulario, declaro bajo gravedad de juramento que la información suministrada es verídica y me comprometo a informar a Comfama si mi condición laboral cambia de desempleado a empleado.
         </p>
      </div>
   )

}

export const FormMentoriaTalentoSection = ({
    fields,
    title,
}: IFormMentoriaTalentoSection) => {
    const { control, getValues } = useFormContext();
    //Campos habilitados para ser diligenciados por el usuario
    const enabledFields = fields.filter((field) => !field.disabled);

    const disabilityOptions = enabledFields
        .filter((field) => field.name === "disability")
        .flatMap((field) => field.options?.map(option => option.value) || []);

    
    const maxLengthField = (type: string) => {
        switch (type) {
            case "mobile":
                return 10; 
            case "phone":
                return 10;         
            case "docNumber":
                return 15;
            default:
                return 170;
        }
    };


    // Función para determinar si un campo debe ser visible
    const shouldFieldBeVisible = (field: Omit<GlobalInputProps,'maxLength'>) => {
        if (!field.fieldMandatory) return true;

        const cityAnswer = getValues("city.answer");
        const dependentFieldValue = getValues(field.fieldMandatory)?.answer;
        const valueFieldMandatory = getValues(field.fieldMandatory.startsWith("!") ? field.fieldMandatory.substring(1) : field.fieldMandatory);
        const valueMentoringInterest = getValues("interesMentoria.answer");
        const isInterested = "Estoy interesado en encontrar o cambiar de empleo";

        const isCityInAmva = listCityAmva.includes(cityAnswer);
        const isCityNotInAmva = !isCityInAmva;

        // Validaciones jobCondition -- statusJob
      //   if (field.name === "jobCondition" && valueFieldMandatory?.answer === "NO") {
      //       return true;
      //   }
        // Validaciones disability -- statusDisability
        if (field.name === "disability" && valueFieldMandatory?.answer === "SÍ") {
            return true;
        }
        // Validacion specialRequirement -- statusDisability
        if (field.name === "specialRequirement" && valueFieldMandatory?.answer ==="SÍ"){
            return true;
        }
        // Validacion specialRequirementDetail -- specialRequirement
        if (field.name === "specialRequirementDetail" && valueFieldMandatory?.answer === "SÍ"){
            return true;
        }
        // Validacion disabilityDetail -- disability
        if (field.name === "disabilityDetail" && disabilityOptions.includes(dependentFieldValue) && dependentFieldValue !== "Física" && isCityInAmva) {
            return true;
        }
        // Validacion disabilityDetail -- disability
        if (field.name === "disabilityDetail" && dependentFieldValue !== "" && isCityNotInAmva) {
            return true;
        }
        // Validacion interesMentoria -- statusDisability
        if (field.name === "interesMentoria" && valueFieldMandatory?.answer === "NO") {
            return true;
        }
        // Validación modMentory AMVA -- statusDisability
        if (field.name === "modMentory" && valueFieldMandatory?.answer !== "" && isCityInAmva) {
            return true;
        }
         // Validacion modMentory REG -- statusDisability //cambiar nombre
         if (field.name === "modMentory" && valueMentoringInterest === isInterested && valueFieldMandatory?.answer === "NO" && isCityNotInAmva ) {
            return true;
        }

        return false;
    };

    const statusJobIsNotEmployed = getValues("statusJob.answer")?.toLowerCase() === UnemploymentLabel?.toLowerCase();

    return (
        <>
            <Grid item xs={12}>
                <TitleDescriptionOne
                    paddingTop={8}
                    paddingBottom={0}
                    title={{
                        content: title,
                        variant: "h4",
                        align: "center",
                        marginBottom: 2,
                    }}
                    />
            </Grid>
            {enabledFields.map(
                (subItem) =>
                    shouldFieldBeVisible(subItem) && (
                        <Grid
                            item
                            xs={12}
                            md={subItem.type === "checkbox" ? 12 : 6}
                            key={subItem.name}
                        >
                            <FormInputLib
                                attributes={{...subItem, maxLength:maxLengthField(subItem.name)}}
                                control={control}
                                tagUseForm={".answer"}
                            />

                            { subItem.name === "statusJob" && statusJobIsNotEmployed && <UnderOathSection /> }
                        </Grid>
                    )
            )}
        </>
    );
};
